import * as S from './styles';

import NextIcon from '@svgIcons/next2.svg';

const GUIDE_BUTTON_KEYS = ['fast_loading', 'data_not_loading'];

export const GuideButtonGroup = {
    name: 'GuideButtonGroup',
    props: {},
    render() {
        return (
            <S.Wrapper>
                {GUIDE_BUTTON_KEYS.map((key) => {
                    return (
                        <S.Button
                            key={`guide_panel_${key}`}
                            onClick={() => {
                                const url = this.$t(
                                    `WIDGET.error_panel.guide_${key}_button_url`
                                );
                                // docs.adriel.com blocks iframe embedding
                                // (X-Frame-Options: DENY), so open in a new tab
                                window.open(url, '_blank', 'noopener,noreferrer');
                            }}
                        >
                            <img
                                src={`/static/assets/img/svg_icons/${key}.svg`}
                            />
                            <div>
                                <S.ButtonTitle>
                                    {this.$t(
                                        `WIDGET.error_panel.guide_${key}_button_title`
                                    )}
                                </S.ButtonTitle>
                                <S.ButtonDesc>
                                    {this.$t(
                                        `WIDGET.error_panel.guide_button_desc`
                                    )}
                                    <NextIcon />
                                </S.ButtonDesc>
                            </div>
                        </S.Button>
                    );
                })}
            </S.Wrapper>
        );
    },
};
